module.exports = __webpack_public_path__ + "img/no-photo.089cb9e9.png";